import { useEffect, useRef, useState } from "react";
function useIntersectionObserver(thresh_val = 0) {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const current = ref.current;
        if (!current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible((prev) => (prev ? true : entry.isIntersecting));
            },
            {
                root: null,
                threshold: thresh_val,
            }
        );

        if (current) {
            observer.observe(current);
        }

        return () => {
            if (current) {
                observer.unobserve(current);
            }
        };
    }, [thresh_val]);
    return [
        ref,
        isVisible,
        `will-fade-in ${isVisible ? "active-fade-in" : ""}`,
    ];
}

export default useIntersectionObserver;
